import { Contrast, DarkMode, LightMode, SettingsBrightness } from '@mui/icons-material';
import { IconButton, ListItemIcon, Menu, MenuItem } from '@mui/material';
import useTranslation from 'hooks/useTranslation/useTranslation';
import React from 'react';
import { ThemeMode } from './ThemeModeProvider';
import useThemeModeContext from './useThemeModeContext';

interface ThemeModeMenuProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  onOpen: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onClose: () => void;
}

const options: { mode: ThemeMode; icon: React.ReactNode; labelKey: 'system_preference' | 'dark' | 'light' }[] = [
  { mode: 'system', icon: <SettingsBrightness />, labelKey: 'system_preference' },
  { mode: 'dark', icon: <DarkMode />, labelKey: 'dark' },
  { mode: 'light', icon: <LightMode />, labelKey: 'light' }
];

const ThemeModeMenu = ({ anchorEl, open, onOpen, onClose }: ThemeModeMenuProps) => {
  const { translation } = useTranslation();
  const { themeMode, setThemeMode } = useThemeModeContext();

  const handleSelect = (mode: ThemeMode) => {
    setThemeMode(mode);
    onClose();
  };

  return (
    <>
      <IconButton
        color="inherit"
        id="appbar-theme"
        title={translation.theme}
        aria-haspopup="true"
        aria-controls={open ? 'appbar-theme-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        onClick={onOpen}
      >
        <Contrast />
      </IconButton>
      <Menu
        id="appbar-theme-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={onClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
      >
        {options.map((option) => (
          <MenuItem
            key={option.mode}
            id={`${option.mode}-menu-item`}
            selected={themeMode === option.mode}
            disabled={themeMode === option.mode}
            onClick={() => handleSelect(option.mode)}
          >
            <ListItemIcon>{option.icon}</ListItemIcon>
            {translation[option.labelKey]}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default ThemeModeMenu;
